import CryptoJS from 'crypto-js';
import { publicKey } from './public.js';
const config = process.env
// Encryption function
export const encryptText = (plainText) => {
  try {
    const encrypted = CryptoJS.AES.encrypt(plainText, publicKey.public).toString();
    return encrypted;
  } catch (error) {
    console.log('Encryption error:', error);
    return null; // or throw error based on your requirement
  }
};

// Decryption function
export const decryptText = (encryptedText,isToken=false) => {
  try {
    const decrypted = CryptoJS.AES.decrypt(encryptedText, publicKey.public).toString(CryptoJS.enc.Utf8);
    if(!decrypted) return null
    if(isToken)return decrypted || null
    return config.REACT_APP_ENABLE_ENCRYPTION === 'true' ? JSON.parse(decrypted) : decrypted
  } catch (error) {
    return null;
  }
};
